module.exports = __webpack_public_path__ + "static/arif-ocean-cd5cf43a652ebcd12fe2de835ffbe432.jpg";